import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'redeem',
    pathMatch: 'full',
  },
  {
    path: 'gift_card',
    loadChildren: () =>
      import('./gift-card/gift-card-wrapper.module').then(
        (m) => m.GiftCardWrapperModule,
      ),
  },
  {
    path: 'points_activity',
    loadChildren: () =>
      import('./points-transaction/points-transaction.wrapper.module').then(
        (m) => m.PointsTransactionWrapperModule,
      ),
  },
  {
    path: 'transfer',
    loadChildren: () =>
      import('./transfer-connect-v2/transfer-connect-v2-wrapper.module').then(
        (m) => m.TransferConnectV2WrapperModule,
      ),
  },
  {
    path: 'errors',
    loadChildren: () =>
      import('./static-error/static-error-wrapper.module').then(
        (m) => m.StaticErrorWrapperModule,
      ),
  },
  {
    path: 'redeem_cash',
    loadChildren: () =>
      import('./redeem-cash-v2/redeem-cash-v2-wrapper.module').then(
        (m) => m.RedeemCashWrapperModule,
      ),
  },
  {
    path: 'offers',
    loadChildren: () =>
      import('./offer/offer-wrapper.module').then((m) => m.OfferWrapperModule),
  },
  {
    path: 'campaigns',
    loadChildren: () =>
      import('./campaign/campaign-wrapper.module').then(
        (m) => m.CampaignWrapperModule,
      ),
  },
  {
    path: 'share_points',
    loadChildren: () =>
      import('./share-points/share-points-wrapper.module').then(
        (m) => m.SharePointsWrapperModule,
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./static-pages/static-pages.module').then(
        (m) => m.StaticPagesModule,
      ),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'disabled',
      initialNavigation: 'disabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
